var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M256 0C114.615 0 0 114.615 0 256s114.615 256 256 256 256-114.615 256-256S397.385 0 256 0zm0 464c-114.875 0-208-93.125-208-208S141.125 48 256 48s208 93.125 208 208-93.125 208-208 208zm-64-320l192 112-192 112z"}));
}

Play.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Play;

Play.default = Play;
